module.exports = __webpack_public_path__ + "static/how-to-share__email-cbe9c7e02041d66f70c8f8607fc97f5e.jpg";